import { SvgIcon, SvgIconProps } from '@mui/material'

export function VideoMessageIcon({ sx, ...props }: SvgIconProps) {
  return (
    <SvgIcon
      viewBox="0 0 16 16"
      sx={{ width: '16px', height: '16px', color: 'gray', ...sx }}
      {...props}
    >
      <path d="M10.67 6.85 7.33 4.92a1.33 1.33 0 0 0-2 1.15v3.86a1.33 1.33 0 0 0 2 1.15l3.34-1.93a1.33 1.33 0 0 0 0-2.3ZM10 8 6.67 9.93V6.07L10 8ZM8 1.33a6.67 6.67 0 1 0 0 13.34A6.67 6.67 0 0 0 8 1.33Zm0 12A5.33 5.33 0 1 1 8 2.67a5.33 5.33 0 0 1 0 10.66Z" />
    </SvgIcon>
  )
}
